import Methods from "../methods";

/**
 * Listar ubicaciones disponibles
 * @param context
 * @param type (BOX | LOCKER)
 */
const getAvailableLocations = (context, type) => {
  let url = "api/storage-locations/available";

  if (type) {
    url += `?type=${type}`;
  }

  return Methods.doGet(context, url);
};

const getWarehouseShelfMap = (context, warehouse, floor) => {
  const url = `api/warehouse-shelves/map?warehouse=${warehouse}&floor=${floor}`;
  return Methods.doGet(context, url);
};

export default {
  getAvailableLocations,
  getWarehouseShelfMap
};



// WEBPACK FOOTER //
// ./src/api/modules/StorageLocationApi.js